import { ProtectedPage } from "@/components/misc/protected";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/draft-experiments/$id/generation/variants/$variantId")({
  component: () => (
    <ProtectedPage requires="org:draft_experiments:generate_read">
      <Outlet />
    </ProtectedPage>
  ),
});
